<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <el-upload style="margin-right: 5px;text-align: right;position: relative;z-index:999;"
          class="attachments-upload personnel-upload" :data="{company:company}" :action="uploadUrl"
          :on-success="handleAvatarSuccess" accept=".xlsx,.xls" :show-file-list="true">
          <el-button size="small" type="primary" :loading="isUpload">导入最新员工花名册</el-button>
        </el-upload>
        <el-radio-group size="mini" v-model="tabType">
          <el-radio-button label="0">在职</el-radio-button>
          <el-radio-button label="1">调动</el-radio-button>
          <el-radio-button label="2">离退休</el-radio-button>
        </el-radio-group>
      </div>
      <label class="label-name">所属公司：</label>
      <el-select size="mini" :disabled="noSelectOrganization" class="organization-select" v-model="company"
        placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.name">
        </el-option>
      </el-select>
    </div>
    <div class="list-title" style="padding:5px 10px 8px;background:#f8f8f8;">
      <!-- 条件搜索 -->
      <h3 class="title" style="float:none;border-bottom:1px #ccc solid;margin-bottom:5px;overflow:hidden;">
        <div class="r" style="padding-bottom:5px;">
          <router-link target="_blank" v-if="backRole('RS_5')" :to="'/Personnel/Human/Info'">
            <el-button type="primary" size="mini">添加新员工</el-button>
          </router-link>
        </div>
        条件搜索
        <span class="tip" style="font-size:12px;">（搜索条件为选填, 然后点击搜索按钮进行搜索）</span>
      </h3>
      <section style="font-size:12px;">
        <div class="filter-item" style="margin-bottom:5px;">
          <label class="label-name">所属部门：</label>
          <el-select size="mini" clearable style="width:120px;" class="organization-select" v-model="filter.childDept"
            placeholder="请选择所属部门">
            <el-option v-for="item in childDeptList" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>

          <label class="label-name" style="margin-left:5px;">性别：</label>
          <el-select v-model="filter.sex" clearable style="width:70px;" size="mini">
            <el-option label="男" value="1"></el-option>
            <el-option label="女" value="2"></el-option>
          </el-select>

          <label class="label-name" style="margin-left:5px;">年龄：</label>
          <el-select v-model="filter.nl.db" clearable style="width:70px;" size="mini">
            <el-option label="大于" value="1"></el-option>
            <el-option label="小于" value="2"></el-option>
          </el-select>
          <span style="width:50px;display:inline-block;">
            <el-input size="mini" type="number" v-model="filter.nl.year"></el-input>
          </span>
        </div>

        <div class="filter-item">
          <label class="label-name">籍贯：</label>
          <span style="width:150px;display:inline-block;">
            <el-input size="mini" v-model="filter.jg"></el-input>
          </span>
          <label class="label-name" style="margin-left:5px;">住址：</label>
          <span style="width:150px;display:inline-block;">
            <el-input size="mini" v-model="filter.address"></el-input>
          </span>
          <label class="label-name" style="margin-left:5px;">姓名：</label>
          <span style="width:150px;display:inline-block;">
            <el-input size="mini" v-model="filter.name"></el-input>
          </span>
          <!-- <el-button type="success" @click="getFilterData()" style="margin-left:5px;" size="mini">搜索</el-button> -->
        </div>
      </section>
    </div>


    <el-table :data="paginationData" border style="width: 100%" :height="tableHeight" v-loading="loading">
      <el-table-column fixed prop="orderNum" label="序号" width="40" align="center">
      </el-table-column>
      <el-table-column fixed prop="gh" label="工号" width="80" align="center">
      </el-table-column>
      <el-table-column fixed prop="name" label="姓名" width="70" align="center">
      </el-table-column>

      <el-table-column prop="department" label="部门" width="130" align="center">
      </el-table-column>
      <el-table-column prop="sex" label="性别" width="60" align="center">
      </el-table-column>
      <el-table-column prop="zw" label="岗位及职务" width="220" align="center">
      </el-table-column>
      <el-table-column prop="rxzsj" label="任现职时间" width="100" align="center">
      </el-table-column>
      <el-table-column prop="syzj" label="上一职级" width="220" align="center">
      </el-table-column>
      <el-table-column prop="rzsj" label="任职时间" width="100" align="center">
      </el-table-column>

      <el-table-column prop="idCard" label="身份证" width="140" align="center">
      </el-table-column>
      <el-table-column prop="joinTime" sortable :sort-method="dateSort_joinTime" label="进公司时间" width="120"
        align="center">
      </el-table-column>
      <el-table-column prop="gl" sortable :sort-method="glSort" label="司龄" width="70" align="center">
      </el-table-column>
      <el-table-column prop="zzTime" sortable :sort-method="dateSort_zzTime" label="转正日期" width="85" align="center">
      </el-table-column>

      <!-- <el-table-column prop="userVO.childDept" label="部门" width="100" align="center">
      </el-table-column>
      <el-table-column label="手机/座机" align="center" width="140">
        <template slot-scope="scope">
          {{ scope.row.userVO.mobile }}
          {{ scope.row.userVO.telephone?(' / '+ scope.row.userVO.telephone):'' }}
        </template>
      </el-table-column>
      <el-table-column label="性别" width="40" align="center">
        <template slot-scope="scope">
          {{ scope.row.userVO.gender==1?"男":"女" }}
        </template>
      </el-table-column>
      <el-table-column prop="idCard" label="身份证" width="140" align="center">
      </el-table-column> -->

      <el-table-column prop="zzmm" label="政治面貌" width="70" align="center">
      </el-table-column>
      <el-table-column prop="fullEdu" label="学历" width="50" align="center">
      </el-table-column>
      <el-table-column prop="fullSchool" label="专业" width="140" align="center">
      </el-table-column>
      <el-table-column prop="position" label="专业技术职称" width="120" align="center">
      </el-table-column>
      <el-table-column prop="userType" label="人员类型" width="170" align="center">
      </el-table-column>
      <el-table-column prop="birthday" sortable :sort-method="dateSort_birthday" label="生日" width="110" align="center">
      </el-table-column>
      <el-table-column prop="nl" label="年龄" width="50" align="center">
      </el-table-column>
      <el-table-column prop="txr" sortable :sort-method="dateSort_txr" label="退休日" width="110" align="center">
      </el-table-column>
      <el-table-column prop="marriage" label="婚否" width="50" align="center">
      </el-table-column>
      <el-table-column prop="birthPlace" label="籍贯" width="100" align="center">
      </el-table-column>
      <el-table-column prop="birthAddress" label="户籍所在地" width="250" align="left">
      </el-table-column>
      <el-table-column prop="homeAddress" label="现住址" width="250" align="left">
      </el-table-column>

      <el-table-column label="手机" prop="phone" align="center" width="140">
        <!-- <template slot-scope="scope">
          {{ scope.row.userVO.mobile }}
          {{ scope.row.userVO.telephone?(' / '+ scope.row.userVO.telephone):'' }}
        </template> -->
      </el-table-column>
      <el-table-column label="短号" prop="dh" align="center" width="70">
        <!-- <template slot-scope="scope">
          {{ scope.row.userVO.mobile }}
          {{ scope.row.userVO.telephone?(' / '+ scope.row.userVO.telephone):'' }}
        </template> -->
      </el-table-column>

      <el-table-column label="劳动合同" align="center">
        <el-table-column prop="ldhtkssj" label="起始日期" width="90" align="center">
        </el-table-column>
        <el-table-column prop="ldhtzzsj" sortable :sort-method="dateSort_ldhtzzsj" label="终止日期" width="90"
          align="center">
        </el-table-column>
        <el-table-column prop="ldhtqx" label="劳动合同期限" width="60" align="center">
        </el-table-column>
      </el-table-column>
      <el-table-column label="社保" align="center">
        <el-table-column prop="sb" label="是否在缴" width="60" align="center">
        </el-table-column>
        <el-table-column prop="sbkssj" label="开始缴纳时间" width="110" align="center">
        </el-table-column>
      </el-table-column>
      <el-table-column label="公积金" align="center">
        <el-table-column prop="gjj" label="是否在缴" width="60" align="center">
        </el-table-column>
        <el-table-column prop="gjjkssj" label="开始缴纳时间" width="110" align="center">
        </el-table-column>
      </el-table-column>

      <el-table-column fixed="right" label="操作" align="center" width="200">
        <template slot-scope="scope">
          <el-button type="danger" plain size="mini" @click="leaveRegister(scope.row)">离退休</el-button>
          <el-tooltip class="item" v-if="backRole('RS_5')" effect="dark" content="查看人员档案" placement="bottom">
            <router-link target="_blank" :to="'/Personnel/Info/' + scope.row.archivesId">
              <i class="iconfont icon-157 meeting-btn-icon mbi-detail"></i>
            </router-link>
          </el-tooltip>
          <el-tooltip class="item" v-if="backRole('RS_5')" effect="dark" content="编辑花名册" placement="bottom">
            <router-link target="_blank" :to="'/Personnel/Human/Info/' + scope.row.archivesId">
              <i class="iconfont icon-xiugai meeting-btn-icon mbi-edit"></i>
            </router-link>
          </el-tooltip>
          <el-tooltip class="item" v-if="backRole('RS_5')" effect="dark" content="删除花名册该人员" placement="bottom">
            <i class="iconfont icon-close meeting-btn-icon mbi-remove" @click="deletePersonnel(scope.row)"></i>
          </el-tooltip>


        </template>
      </el-table-column>

    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <!-- 离退休 -->
    <leave :leaveStatus="leaveStatus" v-on:hideLeaveRegister="hideLeaveRegister()" :userData="userData"
      :userRow="userRow"></leave>
  </div>
</template>

<style lang="scss">
  .personnel-upload {
    .el-upload-list {
      position: absolute;
      z-index: 99999;
      right: 150px;
      top: 0;
      background: #fff;
    }

    .el-upload-list__item:first-child {
      margin-top: 0;
    }
  }
</style>
<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  import Role from '@/Mixins/role'
  import Leave from './leave'
  export default {
    components: {
      UserInfo,
      Leave,
    },
    mixins: [Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        // 导入花名册
        isUpload: false,
        uploadUrl: axios.defaults.baseURL + '/human/archives/import',

        // 离退休
        leaveStatus: false,
        userRow: '',

        organizationListData: [],
        noSelectOrganization: true,
        depId: '',
        tabType: '0',

        // 所属公司
        company: '',


        // 筛选搜索
        filter: {
          //所属部门
          childDept: "",
          nl: {
            db: '', //1：大于 2：小于，
            year: 0,
          },
          sex: "",
          jg: "",
          address: "",
          name: "",


        },
        childDeptList: [],

        // 列表
        loading: true,
        pageSize: 300,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],


        tableHeight: 1000,
      }
    },
    created() {
      console.log(document.documentElement.clientHeight)
      this.tableHeight = document.documentElement.clientHeight - 298
    },
    mounted() {
      let _or = this.organization.length > 0 ? this.organization[0].childDepts : []
      this.organizationListData = this.organizationListData.concat(_or)

      // this.getHumanDetail(this.userData.id)

      this.depId = this.userData.secDepIds.split(",")[0] / 1
      if (this.depId == "7") {
        this.noSelectOrganization = false
      }

      this.company = this.userData.department.split("/")[0]
    },
    methods: {
      // 获取花名册详情
      // getHumanDetail(uid) {
      //   ajax.get('/human/archives/' + uid, "", (res) => {
      //     this.company = res.vo.company
      //   })
      // },

      // 上传成功回调
      handleAvatarSuccess(res, file) {
        // 错误自动跳转到登录页
        if (res.code != 20000) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: 0
          })
        } else {
          this.$message.success("员工花名册导入成功")
          this.isUpload = false
          this.getLists()
        }

      },

      // 排序
      // 日期时间排序
      dateSort(a, b, type) {
        console.log(type)
        let oldTime, newTime
        oldTime = a[type] ? (new Date(a[type])).getTime() : 0
        newTime = b[type] ? (new Date(b[type])).getTime() : 0
        return newTime - oldTime
      },
      // 进公司时间
      dateSort_joinTime(a, b) {
        return this.dateSort(a, b, 'joinTime')
      },
      // 转正时间
      dateSort_zzTime(a, b) {
        return this.dateSort(a, b, 'zzTime')
      },
      // 生日
      dateSort_birthday(a, b) {
        return this.dateSort(a, b, 'birthday')
      },
      // 退休日
      dateSort_txr(a, b) {
        return this.dateSort(a, b, 'txr')
      },
      // 合同终止
      dateSort_ldhtzzsj(a, b) {
        return this.dateSort(a, b, 'ldhtzzsj')
      },
      // 工龄排序
      glSort(a, b) {
        let _a, _b, _y_a, _y_b
        if (!a.gl) {
          _a = 0
        } else {
          _y_a = a.gl.split("月")[0].split("年")
          _a = _y_a[0] * 100 + _y_a[1] / 1
        }
        if (!b.gl) {
          _b = 0
        } else {
          _y_b = b.gl.split("月")[0].split("年")
          _b = _y_b[0] * 100 + _y_b[1] / 1
        }
        return _b - _a
      },

      // 删除人员
      deletePersonnel(row) {
        this.$confirm('此操作将永久删除该人员, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ajax.post('/human/archives/del', {
            archivesId: row.archivesId,
          }, (res) => {
            this.$message.success("删除成功")
            this.getLists()
          })
        }).catch(() => {

        });
      },

      // 跳转人员编辑
      // editPersonnelInfo(row) {
      //   console.log(row)
      //   this.$router.push({
      //     path: '/Personnel/Human/Info/' + (row ? row.archivesId : ''),
      //   })
      // },
      // 隐藏离退休弹窗
      hideLeaveRegister() {
        this.leaveStatus = false
      },
      // 显示离退休弹窗
      leaveRegister(row) {
        console.log(row)
        this.userRow = row
        this.leaveStatus = true
      },
      // 档案详情
      handleDetail(row) {
        // console.log(row)
        this.$router.push('/Personnel/Info/' + row.userId)
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选数据
      getFilterData() {
        // 筛选出所有符合的数据
        this.filterData = []
        for (let i = 0; i < this.listData.length; i++) {
          let _item = this.listData[i]

          // 部门筛选
          let _childDept = true
          if (this.filter.childDept) {
            _childDept = false
            if (_item.department == this.filter.childDept) {
              _childDept = true
            }
          }

          // 性别
          let _sex = true
          if (this.filter.sex) {
            _sex = false
            if (_item.sex == this.filter.sex) {
              _sex = true
            }
          }

          // 年龄
          let _nl = true
          if (this.filter.nl.db && this.filter.nl.year) {
            _nl = false
            switch (this.filter.nl.db) {
              case '1':
                if (_item.nl / 1 > this.filter.nl.year) {
                  _nl = true
                }
                break;
              case '2':
                if (_item.nl / 1 < this.filter.nl.year) {
                  _nl = true
                }
                break;
            }
          }

          // 模糊查询
          // 籍贯
          let _jg = this.isFilterTrue(this.filter.jg, _item.birthPlace)
          // 地址
          let _address = this.isFilterTrue(this.filter.address, _item.birthAddress)
          // 姓名
          let _name = this.isFilterTrue(this.filter.name, _item.name)

          if (_childDept && _sex && _nl && _jg && _address && _name) {
            this.filterData.push(_item)
          }
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // filter模糊筛选
      isFilterTrue(key, value) {
        if (key && value) {
          return value.indexOf(key) == -1 ? false : true
        } else {
          return true
        }
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }

        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        ajax.get('/human/archives/list', {
          'company': this.company,
          'type': this.tabType
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getFilterData()
        })
      },
      // 获取子机构目录
      getChildDeptList() {
        ajax.get('/dept/child/list/byName', {
          company: this.company
        }, (res) => {
          this.childDeptList = res.vo.array
        })
      },
    },
    watch: {
      'company'() {
        this.getLists()
        this.getChildDeptList()
      },

      'tabType'() {
        this.getLists()
      },
      filter: {
        handler(newName, oldName) {
          this.getFilterData()
        },
        deep: true
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/personnel/list.vue